








import { Component, Vue, Provide, Prop } from 'vue-property-decorator';

@Component({
  name: 'newOrder'
})
export default class CombinationProperty extends Vue {
    @Prop() daysOptions: any;

    private selectDate(item: string) {
        this.$emit("returnSalaryDateByMonth", Number(item));
    }

}
